import React, {useEffect} from 'react';
import {useSearch} from "../../features/productSearch";
import {useProductSearchStore} from "../../features/productSearch/model/store";
import ShoppingCartWidget from "../../widget/shoppingCart/ShoppingCartWidget";
import PageHeaderWidget from "./widget/PageHeaderWidget";
import styled from "styled-components";
import {GLOBAL_STYLE_CONFIG} from "../../app/styles/GlobalStyles";
import PageProductSearchWidget from "./widget/PageProductSearchWidget";
import {ErrorBoundary} from "../../shared/ui/ErrorBoundary";

const StyledSearchPageContainer = styled.div`
    background-color: ${props => props.theme.colors.background};
    min-height: 100vh;
`

const SearchPageRoot = () => {
    const {fetchingSearch} = useSearch()
    const {search} = useProductSearchStore();

    useEffect(() => {
        fetchingSearch({searchTerm: search.token, startIndex: 0});
    }, []);

    return (
        <StyledSearchPageContainer className={`${GLOBAL_STYLE_CONFIG.splitByPrefix('page')}`}>
            <ErrorBoundary>
                <PageHeaderWidget/>
            </ErrorBoundary>
            <ErrorBoundary>
                <PageProductSearchWidget/>
            </ErrorBoundary>
            <ErrorBoundary>
                <ShoppingCartWidget/>
            </ErrorBoundary>

        </StyledSearchPageContainer>
    );
};

export default SearchPageRoot;